import { PickupStatus } from "../../../app/data/pickup/status";

export const getStatusClassName = (status: PickupStatus) => {
  let className;
  if (status === PickupStatus.UNASSIGNED) className = "xgs-pickup-assignment__status--unassigned";
  if (status === PickupStatus.ASSIGNED) className = "xgs-pickup-assignment__status--assigned";
  if (status === PickupStatus.COMPLETED) className = "xgs-pickup-assignment__status--completed";
  if (status === PickupStatus.CANCELED) className = "xgs-pickup-assignment__status--canceled";
  return className;
};
